import { Locale } from 'signup-ui-lego-core/constants/Locale';
import imageUrls from './imageUrls';
import { ImageKey } from './ImageKey';
export const InternationalizedImages = {
  [ImageKey.Flywheel]: {
    [Locale.de]: imageUrls.flywheelGerman,
    [Locale.en]: imageUrls.flywheelEnglish,
    [Locale.es]: imageUrls.flywheelSpanish,
    [Locale.fr]: imageUrls.flywheelFrench,
    [Locale.ptBr]: imageUrls.flywheelPortuguese
  },
  [ImageKey.Rever]: {
    [Locale.en]: [imageUrls.rever1x, imageUrls.rever2x, imageUrls.rever3x]
  },
  [ImageKey.SalesLeaderCalendar]: {
    [Locale.en]: imageUrls.salesLeaderCalendar
  },
  [ImageKey.SalesMeetingsCalendar]: {
    [Locale.en]: imageUrls.salesMeetingsCalendar
  },
  [ImageKey.SalesMeetingsConfirmation]: {
    [Locale.en]: imageUrls.salesMeetingsConfirmation
  },
  [ImageKey.TimeslotCalendar]: {
    [Locale.en]: imageUrls.timeslotCalendar
  },
  [ImageKey.Wordpress]: {
    [Locale.en]: imageUrls.wordpressAuthorizationConnect
  }
};
export const getInternationalizedImage = (key, locale) => {
  if (key && InternationalizedImages[key][locale]) {
    return InternationalizedImages[key][locale];
  }

  return InternationalizedImages[key][Locale.en];
};